import { get, put, post, patch, del } from './client.js';

const base = (wsId, entityType, entityId) =>
  `/workspaces/${wsId}/custom-fields/${entityType}/${entityId}`;

const defsBase = (wsId, fieldId) =>
  `/workspaces/${wsId}/custom-fields/definitions/${fieldId}`;

export const getDefinitions    = (wsId, entityType) =>
  get(`/workspaces/${wsId}/custom-fields/definitions/${entityType}`);

export const getAllDefinitions  = (wsId, entityType) =>
  get(`/workspaces/${wsId}/custom-fields/definitions/${entityType}?includeArchived=true`);

export const createDefinition  = (wsId, data) =>
  post(`/workspaces/${wsId}/custom-fields/definitions`, data);

export const updateDefinition  = (wsId, fieldId, data) =>
  patch(defsBase(wsId, fieldId), data);

export const deleteDefinition  = (wsId, fieldId) =>
  del(defsBase(wsId, fieldId));

export const getValues  = (wsId, entityType, entityId) =>
  get(base(wsId, entityType, entityId));

/* fields must be Array<{ fieldId: string, value: string | null }> */
export const setValues  = (wsId, entityType, entityId, fields) =>
  put(base(wsId, entityType, entityId), { fields });

/**
 * CF-01: Batch fetch custom field values for up to 200 entity IDs.
 * entityIds must be an Array<string> (UUIDs).
 * Returns { values: { [entityId]: { [fieldId]: string|null } } }
 */
export const getBatchValues = (wsId, entityType, entityIds) =>
  get(`/workspaces/${wsId}/custom-fields/batch?entityType=${encodeURIComponent(entityType)}&entityIds=${entityIds.map(encodeURIComponent).join(',')}`);
